import React, { useState } from 'react';
import '../FoundersMessage/message.css';

import founder1 from '../../../assets/FounderMessage/samata.webp';
import founder2 from '../../../assets/FounderMessage/bijal.webp'

function Message() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <section className="message-div">
        <div className="introsect">
          <div className="introsect-text">
          <h3 className="text-uppercase">
            Your
            <br /> Time To
            <br /> Reflect
          </h3>
          <button className="mt-3 py-2 px-4" onClick={openModal}>
            <small>Founder's Message</small>
          </button> 
          </div>    
        </div>
      </section>

      {/* Custom Modal */}
      {isModalOpen && (
        <div className="custom-modal-overlay" onClick={closeModal}>
          <div className="custom-modal p-md-4 p-3" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>
              &times;
            </button>
            <div className='founder-div'>
                  <div className='founder-box1  my-4'>
                    <img src={founder1} alt='founder' className='img-fluid float-img' loading='lazy'/>
                    <div className='text-white text-start founder1text'>
                    <p>
                      Simply, a dream turned into reality.
                    </p>
                    <p>
                      For a girl like me who spent most of her childhood roaming around forests and beaches, it was obvious to turn back to the roots after working for
                      some time in a metro city like Mumbai.
                    </p>
                    <p>
                      The aroma of your native soil can never be forgotten. And that pulled me back to this heaven with the vision of building a cute little homestay.
                      Fascinated about the sea, the forest beauty around the shore, coconut farm and cute little village, I fell in love with the location and I started
                      Belantara in 2018.
                    </p>
                    <p>
                      I believe when tourism and sustainability walk hand in hand, it leads to responsible tourism. Here in Belantara we didn't cut a single tree while
                      building residences, nor did we hurt any flora and fauna.
                    </p>
                    <p>
                      We never tried to change or cut the original terrain and landscape. I personally believe, when we care about nature, nature cares about us.
                    </p>
                    <p>
                      <strong>Samata & Aniket</strong>
                    </p>
                  </div>
                  </div>

                <div className='messageheading'>
                  <h3>Message from our Founders ...</h3>
                </div>
            {/* founder box2 */}
                  <div className='founder-box2 my-4'>
                    <img src={founder2} alt='founder' className='img-fluid float-img' loading='lazy'/>
                    <div className='text-white text-start founder1text'>
                    <p>
                    Growing up in Bombay, my parents would take my sister and me to Juhu Beach almost every week. It was during these visits that I fell in love with
                    the sea. What I didn’t realize as a child was that these weekly escapes weren’t just about family bonding—they were therapeutic for my parents, a
                    way to balance the stress of urban life.
                    </p>
                    <p>
                    Over the next four decades, my education and career took me far from those shores, with stints in Virginia and Bangalore. Yet, I always missed the
                    tranquility that the sea provided—the soothing sound of waves and the endless horizon. I longed for the peace and simplicity that I had cherished
                    during those childhood days by the beach.
                    </p>
                    <p>
                    My wife, Pallavi, and I dreamed of building a retreat close to nature, somewhere that would offer the same calm and beauty that we loved. Pallavi
                    has deep roots in coastal Sindhudurg, visiting almost every year for Ganesh Chaturthi, as her father hails from Vengurla. So when our nephew,
                    Aniket, and his wife, Samata, who live in Sindhudurg, invited us to join them in expanding Belantara, we knew it was the perfect opportunity to bring
                    that dream to life.
                    </p>
                    <p>
                    At Belantara, we hope every guest feels enriched by their stay. Each experience we offer is grounded in the timeless beauty of India—its natural
                    landscapes and holistic traditions carefully preserved. Whether you come to relax or explore, we believe you’ll leave feeling rejuvenated and recon-
                    nected with both yourself and nature.
                    </p>
                    <p>
                    It is our pleasure to welcome you to Belantara—our home away from home, and now, yours.
                    </p>
                    <p>
                      <strong>Bijal & Pallavi</strong>
                    </p>
                  </div>
                  </div>
                  
                </div>

          </div>
        </div>
      )}
    </>
  );
}

export default Message;
